/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react'
import classNames from 'classnames'
import { Spacer, Button, Checkbox, Field } from '@cleartrip/bento'

import { isEmpty } from 'AccountsUtils'
import { sendClevertapUIActionEvent as ClevertapEvent } from 'AccountsUtils'

import { Divider } from '@cleartrip/bento/components/Divider'
import FKlogo from 'SVGPath/fkSSO'

import { resolveKeysInObjectsArrays } from 'AccountsUtils'
import OfflineToast from '../offlineToast'
import { SVGComponent } from '../..'
import { sendOtpForSignIn } from '../../../pages/Trips/trips.helper'
import { errorConfig } from './errorConfig'
import USER_PROFILE_PAGE_CONTANTS from '../UserProfileConstants'
import OtpBox from './otpBox'
import ModalHeader from '../UserProfileModalHeader'
import SkippableBanner from './SkippableBanner'
import SkippableBannerPWA from './SkippableBannerPWA'
import { isMobileSiteJSversion, isMsiteInAppWebview, path } from '../../../utils/common'
import { apiPostHelper, checkMobileDevice } from '../../../utils'
import { triggerClevertap, getClevertapPlatform } from '../../../utils/clevertap'
import { Toast } from '@cleartrip/bento/components/Toast'

const LoginWithMobile = ({
  isFocus,
  isPwa,
  mobileAndCountryCodeItem,
  setPageName,
  validateMobileHandler,
  isMobileValid,
  handleLinkClick,
  toggle,
  mobile,
  countryCode,
  setMobileValid,
  initialRender,
  setInitialRender,
  abLogin='a',
  showFkSSO='b',
  showFkSSOPwa='b'
}) => {
  const animationDefaultState = {
    isAnimate: false,
    direction: 'right',
    isFadeIn: false
  }
  const [loading, setLoading] = useState(false)
  const [otpDigits, setOtpDigits] = useState(['', '', '', '', '', ''])
  const [apiError, setApiError] = useState('')
  const [countDown, setCountDown] = useState(0)
  const [retriesLeft, setRetriesLeft] = useState(4)
  const [animationParams, setAnimationParams] = useState(animationDefaultState)
  const [isSticky, setSticky] = useState(false)
  const [vheight, setVheight] = useState(window.innerHeight)
  const [isFullHeight, setFullHeight] = useState(false)
  const [loginSwitch, setLoginSwitch] = useState(true)
  const [showFKerrorToast, setShowFKerrorToast] = useState(false)
  const skippableBlock = useRef(null)
  const loginContainer = useRef(null)
  const helpText =
    'We no more support email based login. You can now login via mobile number & link email to access your account.'

  const animatedClass = classNames({
    'slide-in-right':
      animationParams.direction === 'right' && animationParams.isAnimate,
    'slide-in-left':
      animationParams.direction === 'left' && animationParams.isAnimate,
    'px-8': 'px-8'
  })

  const getOtpValue = () => {
    const otp = otpDigits.join('')
    return otp
  }

  const isIosDevice = () => {
    const userAgent = path(['navigator','userAgent'], window)?.toLowerCase()
    const safari = /safari/.test( userAgent ); // checks if website is running in any browser in apple device
    const ios = /iphone|ipod|ipad/.test( userAgent ); // checks if device is among iphone, ipad or ipod
    
    if((ios && !safari) || // checks if device is of ios but not running in browser
        path(['iosData', 'app-agent'], window)){   // checks ios data
            return true
    }
    return false
}

const checkAndroidAndJSversion = () => {
  let showButton = false
  if(isMsiteInAppWebview()) {
      if(isMobileSiteJSversion(5)) {
          showButton = true
      } else {
          showButton = false
      }
  } else {
      showButton = true
  }
  return showButton
}

const showFkButton = () => {
  if(!isIosDevice() && checkMobileDevice() && checkAndroidAndJSversion() ){
      if(path(['androidData', 'app-agent'], window) && path(['androidData', 'js-version'], window) && showFkSSO === 'a'){
          return true
      }
      else if (showFkSSOPwa ==='a' ){
          return true
      }       
  }
  return false
}

 const getSSOredirectionData = async (successPageUri, signupPageUri, fallbackUri, provider) => {
  try {
    const payload = {
      provider: provider,
      currentPageUri: successPageUri,
      fallbackUri: fallbackUri,
      signupPageUri: signupPageUri
    }

    const DOMAIN = path(['location', 'host'], window)
    console.log('checklog:', `${DOMAIN}/oauth2/redirectionInfo`);
    const response = await apiPostHelper(
      `/oauth2/redirectionInfo`,
      payload,
      true,
      {},
      { 
        'Content-Type': 'application/json',
        caller: path(['location', 'origin'], window)
       }
    )
    console.log('checklog:', response);
    return response
  } catch (e) {
    logError(e)
  }
}

const handleFKloginClick = async () => {
  try {
      let eventName = 'Account_UI_Action'
      triggerClevertap(eventName, {
          action_name: 'login_with_fk_clicked',
          platform: getClevertapPlatform() || ''
      })
      let host = path(['location','origin'], window)
      if(host?.includes('0.0.0.0:3000') || host?.includes('localhost:3000') ) {
        host = 'https://qa2new.cleartrip.com'
      }
      let successPageUri = host
      let signupUri = host + '/personal-details?service=/flights'
      let fallbackUri = host + '/signin?service=/flights'

      const res = await getSSOredirectionData(successPageUri, signupUri, fallbackUri, 'flipkart')
      if (res?.status === 200 && res?.data) {
          if (path(['androidData', 'app-agent'], window) && path(['androidData', 'js-version'], window)) {
              if(typeof path(['MobileApp','onNavigationChange'], window) === 'function' ) {
                  let params = res.data.params
                  params.redirectURI = host?.includes('qa2new') ? 'https://qa2new.cleartrip.com/dl/oauth2' :  'https://www.cleartrip.com/dl/oauth2'
                  window.MobileApp.onNavigationChange(
                      JSON.stringify({
                      type: 'FkSSO',
                      miscData: params
                      })
                  )
              }
          } else if(res?.data?.redirectUri){
              let url = res.data.redirectUri + '?'
              for(let key in res?.data?.params) {
                  url += key + '=' + res.data.params[key] + '&'
              }
              window.location.href = url
          }
      } else {
          setShowFKerrorToast(true)
          setTimeout(()=>{
              setShowFKerrorToast(false)
          },2500)
      }
    } catch (error) {
    }
}

  const errorInfo = 'fs-inherit c-inherit pl-2'
  const disabled = getOtpValue().length != 6
  const query = resolveKeysInObjectsArrays(['location', 'pathname'], window)
  const pathname = query.split('/')
  const pagePath = pathname[2]
  const bannerAnimationRef = useRef()
  useEffect(() => {
    ClevertapEvent({
      actionName: 'Login_Signup_modal_opened',
      actionType: 'Button',
      login_banner_cookie: abLogin,
      page:
        pagePath === 'results'
          ? 'SRP'
          : isEmpty(pagePath)
          ? 'HP'
          : pathname.length > 4 &&
            pathname[4] === 'info' &&
            pathname[2] === 'itinerary'
          ? 'Itinerary'
          : 'Confirmation_Page'
    })
  }, [])


  useEffect(()=>{
    if(mobile?.length === 10 && validateMobileHandler()){
        getOtp()
    }
}, [mobile])

  const handleScroll = () => {
    if (skippableBlock.current.getBoundingClientRect().top < 10) {
      setFullHeight(true)
    }
    // if (skippableBlock.current?.getBoundingClientRect()?.top < 0 ||
    //   skippableBlock.current?.getBoundingClientRect()?.top === 0) {
    //   setSticky(true)
    // }
  }

  useEffect(() => {
    if (isFocus) {
      setSticky(true)
    }
    if (skippableBlock.current.getBoundingClientRect().top < 10) {
      setFullHeight(true)
    } else {
      // setSticky(false)
      setFullHeight(false)
    }
    document.body.classList.add('o-hidden')
    // let containerHeight = skippableBlock.current
    const updateWindowDimensions = () => {
      const newHeight = window.innerHeight
      setVheight(newHeight)
      loginContainer.current.scrollIntoView({ block: 'center' })
    }
    window.addEventListener('resize', updateWindowDimensions)
    return () => {
      window.removeEventListener('resize', updateWindowDimensions)
      document.body.classList.remove('o-hidden')
    }
  }, [loginSwitch, isFocus, isSticky])

  const getOtp = async () => {
    setApiError('')
    const mobileValid = validateMobileHandler()
    ClevertapEvent({
      actionName: 'Get_OTP_entered_on_login modal',
      login_banner_cookie: abLogin,
      actionType: 'Button',
      page:
        pagePath === 'results'
          ? 'SRP'
          : isEmpty(pagePath)
          ? 'HP'
          : pathname.length > 4 &&
            pathname[4] === 'info' &&
            pathname[2] === 'itinerary'
          ? 'Itinerary'
          : 'Confirmation_Page'
    })
    try {
      if (mobileValid) {
        setLoading(true)
        ClevertapEvent({
          actionName: 'Mobile_number_entered_on_login_modal',
          actionType: 'Button',
          login_banner_cookie: abLogin,
          page:
            pagePath === 'results'
              ? 'SRP'
              : isEmpty(pagePath)
              ? 'HP'
              : pathname.length > 4 &&
                pathname[4] === 'info' &&
                pathname[2] === 'itinerary'
              ? 'Itinerary'
              : 'Confirmation_Page'
        })
        const payload = {
          type: 'MOBILE',
          value: mobile,
          countryCode,
          action: 'SIGNIN'
        }
        const response = await sendOtpForSignIn(payload)
        const { status, data, error } = response || {}
        if (status === 202) {
          const { action } = data || {}
          setPageName(USER_PROFILE_PAGE_CONTANTS.VERIFY_MOBILE_NUMBER)
        } else {
          const { response = { data: {} } } = error || {}
          const { data = {} } = response
          const { message } = data
          const errRes = errorConfig[message] || errorConfig.default
          ClevertapEvent({
            actionName: 'Error_Occured_Login_modal',
            actionType: 'Button',
            login_banner_cookie: abLogin,
            page:
              pagePath === 'results'
                ? 'SRP'
                : isEmpty(pagePath)
                ? 'HP'
                : pathname.length > 4 &&
                  pathname[4] === 'info' &&
                  pathname[2] === 'itinerary'
                ? 'Itinerary'
                : 'Confirmation_Page',

            error_type:
              message === 'OTP_SEND_LIMIT_EXCEEDED'
                ? 'OTP limit exceeded'
                : 'OTP generation failed'
          })
          setApiError(errRes)
        }
        setLoading(false)
      } else {
        ClevertapEvent({
          actionName: 'Invalid_value_entered',
          login_banner_cookie: abLogin,
          actionType: 'Button',
          page:
            pagePath === 'results'
              ? 'SRP'
              : isEmpty(pagePath)
              ? 'HP'
              : pathname.length > 4 &&
                pathname[4] === 'info' &&
                pathname[2] === 'itinerary'
              ? 'Itinerary'
              : 'Confirmation_Page',

          field_name: 'mobile',
          form_name: 'LoginSignUp'
        })
      }
    } catch (e) {
      console.log('otp api error', e)
    }
  }

  useEffect(() => {
    const OutsideClickHandler = event => {
      if (!bannerAnimationRef.current.contains(event.target)) {
        setInitialRender(true)
        toggle()
      }
    }
    document.addEventListener('mousedown', OutsideClickHandler)
    return () => {
      document.removeEventListener('mousedown', OutsideClickHandler)
    }
  })

  useEffect(() => {
    setTimeout(() => {
      setInitialRender(false)
    }, 1000)
  }, [])

  return (
    <div
      ref={bannerAnimationRef}
      onScroll={handleScroll}
      className={`${isSticky ? 't-0 bg-white' : 'b-0 flex-between '} 
      ${
        isPwa
          ? 'flex flex-column overflow-y-scroll z-2 w-100p p-fixed'
          : `${initialRender ? 'bannerAnimation p-relative' : ''} d-flex`
      } `}
      style={{
        background: isPwa ? '#00000080' : '#ffffff',
        height: isPwa ? vheight : 'auto'
      }}
    >
      {isPwa && (
        <div className="p-sticky t-0 w-100p p-fixed z-20 ">
          {isSticky && (
            <div className="bg-orange-100 bg-white-f7 elevation-lg flex flex-row flex-middle">
              <span
                className="d-ib px-5  py-4 fs-12 fw-700 c-white"
                onClick={toggle}
              >
                <SVGComponent
                  svgIcon="crossDark"
                  height={24}
                  width={24}
                  className="c-pointer c-white"
                />
              </span>
              <span className="d-ib fs-16 fw-600 lh-24 c-black">
                Sign up / Log in
              </span>
            </div>
          )}
        </div>
      )}
      <div ref={skippableBlock}>
        {isPwa ?
          <SkippableBannerPWA isSticky={isSticky} isPwa={isPwa}  toggle={toggle} abLogin={abLogin} />:
          <SkippableBanner abLogin={abLogin} />
        }
          
      </div>

      <div
        className={`${animatedClass} d-flex flex-1 flex-column bg-white`}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            getOtp()
          }
        }}
        style={{
          width: isPwa ? 'auto' : '416px',
          height: '437px'
        }}
      >
        {isPwa ? (
          <div className="pt-6" />
        ) : (
          <ModalHeader title="" toggle={toggle} />
        )}
        <OfflineToast page="proceed" />
        {apiError && (
          <>
            <div className="py-2 px-2 h-8 flex flex-middle bg-error-600 c-white fs-2 br-4 ">
              <SVGComponent
                svgIcon="info_icon"
                className="c-white"
                height={16}
                width={16}
              />
              <span data-testid="signinError" className={errorInfo}>
                {apiError}
              </span>
            </div>
            <Spacer className="pt-4" />
          </>
        )}
        {isPwa && (
          <>
            <h1 class="fs-24 fw-600">Let’s get started</h1>
            <p class="color-neutral-500 fs-3 fw-500 pb-6 pt-2">
              Please enter your mobile number to continue
            </p>
          </>
        )}
        <div className="d-flex flex-1 flex-between flex-column">
          <div>
            {mobileAndCountryCodeItem}
            <Spacer className="mt-6" />
            <div style={{borderRadius: '8px'}}>
              <div ref={loginContainer} />
              <Button
                className="br-8-imp h-10 bg-black-500 hover:bg-black-500" 
                disabled={!disabled}
                size="md"
                type="secondary"
                busy={loading}
                full={true}
                onClick={() => getOtp()}
              >
                <span className={`${!disabled ? 'c-grey-30' : ''} fs-3 fw-500`}>
                  Get OTP
                </span>
              </Button>
            </div>
            <If condition = {showFkButton() }>
                <div className='flex mt-6'>
                    <div className='bg-c-e6 mt-2 mb-6px mr-2 flex-1' />
                    <div className='fs-2 fw-500 color-neutral-500'>
                        or
                    </div>
                    <div className='bg-c-e6 mt-2 mb-6px ml-2 flex-1' />
                </div>
                <div className='border-1-black mt-6 br-2 fs-3 fw-600 flex flex-center flex-middle' style={{borderRadius: '8px', height: '40px'}} onClick={handleFKloginClick}>
                    <div className='flex'>
                        <FKlogo /> <div className='ml-8'> Login with Flipkart </div>
                    </div>
                </div>
                {
                  showFKerrorToast && <div className='p-absolute b-4 w-80p'>
                    <Toast
                      messageType="warning"
                      messageClass="fw-500"
                      containerClass="ml-0"
                      message={'Something went wrong. Retry!'}
                      onCancel={() => {
                      }}
                      showCloseButton={false}
                    />
                  </div>
                }
                <Else />
                <div
                  className="mt-3 fs-12 fw-400"
                  style={{ color: '#666666', textAlign: 'center' }}
                >
                  {helpText}
                </div>
            </If>
          </div>
          <div className="mb-5">
            <Divider className="bc-grey-10" />
            <div className="mt-5 d-flex flex-middle">
              <span>
                <span className="fs-1 c-grey-70">
                  By continuing, you agree to Cleartrip's
                </span>
                <span
                  className="fs-1 fw-500 c-blue c-pointer"
                  onClick={() => handleLinkClick('privacy-policy')}
                >
                  {' '}
                  privacy policy
                </span>{' '}
                <span className="fs-1 c-grey-70">&</span>{' '}
              </span>
              <span>
                <span
                  className="fs-1 fw-500 c-blue c-pointer ml-1"
                  onClick={() => handleLinkClick('terms-of-service')}
                >
                  {' '}terms of use.
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginWithMobile
